<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.4818 4C26.1781 4 29.3337 8.47 29.3337 12.64C29.3337 21.085 16.2374 28 16.0003 28C15.7633 28 2.66699 21.085 2.66699 12.64C2.66699 8.47 5.82255 4 10.5188 4C13.2151 4 14.9781 5.365 16.0003 6.565C17.0225 5.365 18.7855 4 21.4818 4Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
